import React from 'react';
import clsx from 'clsx';

import './CommonPage.scss';

function CommonPage({ className, children }) {
  return <div className={clsx('common-page', className)}>{children}</div>;
}

export default CommonPage;
